import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 10);

  return (
    <section className="py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最近更新
          </h2>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
          >
            更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className="w-14 h-20 rounded-md overflow-hidden flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover"
                  title={comic.title}
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {comic.title}
                </h4>
                <p className="text-xs text-foreground-500 mt-1">作者：{comic.author}</p>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-xs text-primary-600 font-medium">更新至第{comic.chapters}话</span>
                  <span className="text-xs text-foreground-400">{comic.updatedAt}</span>
                </div>
              </div>
              <div className="flex-shrink-0">
                <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-50 text-primary-700">
                  {comic.category === 'korean' ? '韩漫' : comic.category === 'japanese' ? '日漫' : '国漫'}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}